import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  [
    'path',
    {
      d: 'M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 .83.18 2 2 0 0 0 .83-.18l8.58-3.9a1 1 0 0 0 0-1.832z',
      key: 'tq134k',
    },
  ],
  ['path', { d: 'M16 17h6', key: '1ook5g' }],
  ['path', { d: 'M2.003 11.995a1 1 0 0 0 .597.915l8.58 3.91a2 2 0 0 0 .83.18', key: '8mjqed' }],
  [
    'path',
    {
      d: 'M2.003 16.995a1 1 0 0 0 .597.915l8.58 3.91a2 2 0 0 0 .83.18 2 2 0 0 0 .83-.18l2.11-.96',
      key: '7vwz41',
    },
  ],
  ['path', { d: 'M22.018 12.004a1 1 0 0 1-.598.916l-.177.08', key: 'bm5b9y' }],
];

/**
 * @component @name LayersMinus
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuODMgMi4xOGEyIDIgMCAwIDAtMS42NiAwTDIuNiA2LjA4YTEgMSAwIDAgMCAwIDEuODNsOC41OCAzLjkxYTIgMiAwIDAgMCAuODMuMTggMiAyIDAgMCAwIC44My0uMThsOC41OC0zLjlhMSAxIDAgMCAwIDAtMS44MzJ6IiAvPgogIDxwYXRoIGQ9Ik0xNiAxN2g2IiAvPgogIDxwYXRoIGQ9Ik0yLjAwMyAxMS45OTVhMSAxIDAgMCAwIC41OTcuOTE1bDguNTggMy45MWEyIDIgMCAwIDAgLjgzLjE4IiAvPgogIDxwYXRoIGQ9Ik0yLjAwMyAxNi45OTVhMSAxIDAgMCAwIC41OTcuOTE1bDguNTggMy45MWEyIDIgMCAwIDAgLjgzLjE4IDIgMiAwIDAgMCAuODMtLjE4bDIuMTEtLjk2IiAvPgogIDxwYXRoIGQ9Ik0yMi4wMTggMTIuMDA0YTEgMSAwIDAgMS0uNTk4LjkxNmwtLjE3Ny4wOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/layers-minus
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LayersMinus = createLucideIcon('layers-minus', __iconNode);

export default LayersMinus;
